import { useState } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Typography, Icon, IconSize } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getCarrierSectionStyles, getCarrierLogoStyles, getCarrierCaptionStyles, getCarrierContractStyles, getCarrierContractIconStyles, getCarrierContractCaptionStyles } from './CarrierStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Carrier = _ref => {
  let {
    carrierImageAlt,
    carrierlogo: carrierLogoProps,
    carrierFallbackLogo,
    serviceName,
    isOwnContract
  } = _ref;
  const {
    t
  } = useTranslation();
  const [carrierLogo, setCarrierLogo] = useState(carrierLogoProps);
  const onLogoError = () => {
    if (carrierFallbackLogo) {
      setCarrierLogo(carrierFallbackLogo);
    }
  };
  return jsxs("section", {
    css: getCarrierSectionStyles,
    children: [jsx("img", {
      css: getCarrierLogoStyles(isOwnContract),
      alt: carrierImageAlt,
      src: carrierLogo,
      onError: onLogoError
    }), jsx(Typography, {
      variant: "small",
      css: getCarrierCaptionStyles,
      children: serviceName
    }), isOwnContract && jsxs("section", {
      css: getCarrierContractStyles,
      children: [jsx(Icon, {
        css: getCarrierContractIconStyles,
        size: IconSize.SIZE_SMALL,
        name: IconNames.CONTRACT
      }), jsx(Typography, {
        variant: "small",
        css: getCarrierContractCaptionStyles,
        children: t('service-card.carrier.contract')
      })]
    })]
  });
};

export { Carrier };
//# sourceMappingURL=Carrier.js.map
